import { render } from "./EntryTypeSelector.vue?vue&type=template&id=19e99dc8"
import script from "./EntryTypeSelector.vue?vue&type=script&lang=js"
export * from "./EntryTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__